import React, { PureComponent } from 'react';

import PowerexMark from '../media/PowerexMark.png';

import './Status.css';

export class Status extends PureComponent {
  static displayName = Status.name;

  render () {
    return (
      <div className="pwx-status-container">
        <img src={PowerexMark} alt="Powerex Mark" />
        <span className="pwx-status-content">
          {this.props.statusContent}
        </span>
      </div>
    );
  }
}